// extracted by mini-css-extract-plugin
export default {"MainMenu":"MainMenu_MainMenu__oINnM","Visible":"MainMenu_Visible__kjc2p","MenuContainer":"MainMenu_MenuContainer__6zxde","ShrunkNavigationBar":"MainMenu_ShrunkNavigationBar__0b5KU"};